import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

const PAGE_TYPES_ENDPOINT = "v2/content/pagetypes";

@Injectable({
	providedIn: "root",
})
export class CommonContentConfigService {
	constructor(private service: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	getCustomerSupportSectionEndpoint(): string {
		return this.service.get(
			(x) => x.common.content.endpoint?.customerSupportSection,
			`${PAGE_TYPES_ENDPOINT}/customersupport`
		);
	}

	getCashDeskEndpoint(): string {
		return this.service.get((x) => x.common.content.endpoint?.cashDesk, `${PAGE_TYPES_ENDPOINT}/cashdesk`);
	}
}
